import { tKeys, useTranslation } from 'locales';
import { capitalize } from 'remeda';
import type { Sync, SyncState } from 'shared/hooks/use-load-syncs';

const STATE_LABEL_KEYS: Record<SyncState, string | null> = {
  never_synced: tKeys.NAV.SYNC.NEVER_SYNCED,
  running: tKeys.NAV.SYNC.RUNNING,
  healthy: null,
  failing: tKeys.NAV.SYNC.FAILING,
};

export const useSyncStatusLabel = () => {
  const { t } = useTranslation();

  return (sync: Sync) => {
    const labelKey = STATE_LABEL_KEYS[sync.state];

    return labelKey === null ? capitalize(sync.lastSuccessAt?.fromNow() ?? '') : t(labelKey);
  };
};
